import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ProposalsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import { resumeDataInterface } from '../../interfaces/resume';

import { Proposals } from '../../interfaces/proposals';

@Component({
  selector: 'mcrit-gestio-last-incidencia-6',
  templateUrl: './last-incidencia-6.component.html',
  styleUrls: ['./last-incidencia-6.component.css'],
  providers: [ProposalsService]
})
export class LastIncidencies6Component implements OnInit {
  public activeProposals: Array<Proposals> = [];
  public rol: any = 0;
  public resumeData: resumeDataInterface = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
  
  public createProposal(){this.router.navigate(['project', 'new']);}

  public navigateToProposal(proposal){this.router.navigate(['project', proposal.codi]);}

  public viewAllProposals(){this.router.navigate(['project']);}

  constructor(private proposalsService: ProposalsService, private router: Router, private tokenStorage: TokenStorageService) {}
 
  ngOnInit() {
    this.proposalsService.getFActive(1000, 0,{stateContracted: true},
    { //ORDRE DE LES PROPOSTES QUE ES MOSTREN A INICI (data factura)
    })
    .subscribe(
      proposals => {this.activeProposals = proposals.rows;this.rol = this.tokenStorage.getRol();
      this.resumeData = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0, totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
      this.activeProposals.map(item => {
        if(item.empresa != "Consorci")
          switch(item.ambit_proposta){
           case 'Europa': this.resumeData.ambit.totalEU+=item.import_propi;this.resumeData.ambit.numEU++;break;
           case 'Internacional': this.resumeData.ambit.totalInt+=item.import_propi;this.resumeData.ambit.numInt++;break;
           case 'Espanya': this.resumeData.ambit.totalE+=item.import_propi;this.resumeData.ambit.numE++;break;
           case 'Catalunya': this.resumeData.ambit.totalCAT+=item.import_propi;this.resumeData.ambit.numCAT++;break;
          };
        switch(item.empresa){
          case 'MCRIT': this.resumeData.empresa.totalMCRIT+=item.import_propi;this.resumeData.empresa.numMCRIT++;break;
          case 'Multicriteri': this.resumeData.empresa.totalMULTI+=item.import_propi;this.resumeData.empresa.numMULTI++;break;
          case 'Multicriteri MCRIT AIE': this.resumeData.empresa.totalAIEMULTI+=item.import_propi;this.resumeData.empresa.numAIEMULTI++;break;
          case 'Ersília': this.resumeData.empresa.totalERSI+=item.import_propi;this.resumeData.empresa.numERSI++;break;
          case 'Geovincles': this.resumeData.empresa.totalGEO+=item.import_propi;this.resumeData.empresa.numGEO++;break;
        }
      });
      },
      error => console.log(error)
    );

  }

}
